<template>
    <footer class="app-footer bg-dark text-light py-4">
        <div class="container">
            <div class="row">
                <div class="col-md-4 mb-4 mb-md-0">
                    <h5>Selam Rachunkowość</h5>
                    <p>Profesjonalne usługi księgowe, podatkowe i kadrowo-płacowe dla firm i osób prowadzących
                        działalność gospodarczą.</p>
                    <!-- <div class="social-icons">
                        <a href="#" class="me-2"><i class="fab fa-facebook"></i></a>
                        <a href="#" class="me-2"><i class="fab fa-linkedin"></i></a>
                        <a href="#" class="me-2"><i class="fab fa-instagram"></i></a>
                    </div> -->
                </div>
                <div class="col-md-4 mb-4 mb-md-0">
                    <h5>Kontakt</h5>
                    <address>
                        <p><i class="fas fa-map-marker-alt me-2"></i> ul. Gościnna 7, 05-082 Warszawa / Blizne
                            Łaszczyńskiego</p>
                        <p><i class="fas fa-phone me-2"></i> +48 571 464 177</p>
                        <p><i class="fas fa-envelope me-2"></i> biuro@selam.com.pl</p>
                    </address>
                </div>
                <div class="col-md-4">
                    <h5>Szybkie linki</h5>
                    <ul class="list-unstyled">
                        <li><router-link to="/" class="text-decoration-none text-light">Strona główna</router-link></li>
                        <li><router-link to="/oferta" class="text-decoration-none text-light">Oferta</router-link></li>
                        <li><router-link to="/cennik" class="text-decoration-none text-light">Cennik</router-link></li>
                        <li><router-link to="/kontakt" class="text-decoration-none text-light">Kontakt</router-link>
                        </li>
                        <li><router-link to="/strefa-klienta" class="text-decoration-none text-light">Strefa
                                Klienta</router-link></li>
                    </ul>
                </div>
            </div>
            <hr class="my-4">
            <div class="text-center">
                <p class="mb-0">&copy; {{ new Date().getFullYear() }} Selam Rachunkowość. Wszelkie prawa zastrzeżone.
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'AppFooter'
}
</script>

<style lang="scss" scoped>
.app-footer {
    margin-top: 2rem;

    h5 {
        font-weight: 600;
        margin-bottom: 1.2rem;
    }

    .social-icons {
        a {
            color: white;
            font-size: 1.4rem;
            transition: color 0.3s ease;

            &:hover {
                color: var(--accent-color);
            }
        }
    }

    ul li {
        margin-bottom: 0.5rem;
    }
}
</style>